<template>
  <div class="">
    <!-- header section start  -->
    <section class="text-center">
      <p
        class="mb-0 font-extrabold text-base md:text-xl"
        style="color: #8a94a6"
      >
        Pricing
      </p>
      <!-- <h2 class="text-black font-black tracking-wide text-2xl md:text-4xl">
        Plans to help you grow your business
      </h2> -->
    </section>
    <!-- header section end   -->
    <!-- pricing table  -->
    <section class="mt-10">
      <section
        class="flex flex-wrap justify-center mt-10 md:mt-16 md:px-20 lg:px-0"
      >
        <div
          class="mt-5 xl:mt-0"
          v-for="(cardData, index) in pricingTable"
          :key="index + cardData.title"
        >
          <div
            :class="[
              'rounded-3xl shadow-lg p-10 pricing_main_div',
              cardData.onFocus
                ? ' border-primaryColor border-4'
                : 'border-gray-300',
            ]"
          >
            <h4
              :class="[
                'text-xl font-semibold',
                cardData.onFocus ? ' text-primaryColor ' : ' text-gray-800',
              ]"
            >
              {{ cardData.title }}
            </h4>
            <p class="text-base font-medium text-gray-800 mt-5">
              {{ cardData.description }}
            </p>
            <!-- <h3 class="text-3xl font-semibold mt-5 mb-0">
              {{ activeTab === 'monthly' ? cardData.monthly : cardData.yearly }}
              <span class="text-base text-gray-700"
                >{{
                  cardData.title === 'Business' ? '/ month and up' : '/ month'
                }}
              </span>
            </h3> -->
            <!-- <p class=" italic text-base font-medium text-gray-700"> {{ activeTab === 'monthly' ? 'Per user' : 'Per user billed annually' }} </p> -->
            <button
              v-if="cardData.title !== 'Business'"
              :class="[
                'btn w-full hover:bg-primaryColor mt-2',
                cardData.onFocus ? ' btn-primary ' : 'btn-outline',
              ]"
            >
              Get Started
            </button>
            <a
              href="https://twitter.com/messages/14603308-1448512543505272835?recipient_id=14603308"
              target="_blank"
              v-if="cardData.title === 'Business'"
              :class="[
                'btn w-full hover:bg-primaryColor mt-2',
                cardData.onFocus ? ' btn-primary ' : 'btn-outline',
              ]"
            >
              Contact us
            </a>
            <ul :class="['mt-10']">
              <li
                v-for="(data, index) in cardData.keyPoints"
                :key="index + data.title"
                :class="['mt-5']"
              >
                <font-awesome-icon
                  class="reaction text-gray-800 mr-4 font-thin"
                  size="lg"
                  :icon="['fas', 'check']"
                />
                {{ data.title }}
              </li>
            </ul>
          </div>
        </div>
        <!-- contact us hight ticket  -->
        <!-- <div
          :class="[
            'border rounded-3xl p-5 flex-1 max-h-40',
            false ? ' border-primaryColor border-4' : 'border-gray-300',
          ]"
          style="max-width: 290px"
        >
          <h4
            :class="[
              'text-xl font-semibold',
              false ? ' text-primaryColor ' : ' text-gray-800',
            ]"
          >
            high-ticket
          </h4>
          <a
          href="https://twitter.com/messages/14603308-1448512543505272835?recipient_id=14603308"
          target="_blank"
            :class="[
              'btn w-full hover:bg-primaryColor mt-5',
              false ? ' btn-primary ' : 'btn-outline',
            ]"
          >
            Contact Us
          </a>
        </div> -->
      </section>
    </section>
  </div>
</template>

<script>

export default {
  name: 'PricingTable',
  layout: 'null',
  data() {
    return {
      activeTab: 'yearly',
      pricingTable: [
        {
          title: 'Free',
          description: 'Figure out Twitter',
          monthly: '0',
          yearly: '$0',
          onFocus: false,
          keyPoints: [
            {
              title: 'Powerful list building',
            },
            {
              title: 'Quick Engagement tools',
            },
            {
              title: 'Group & Manage DMs',
            },
            {
              title: 'Manage up to 100 contacts',
            },
          ],
        },
      ],
    };
  },
};
</script>

<style>
</style>
